import { isError } from '../guards/index.js';

async function requestCameraPermission() {
  try {
    await navigator.mediaDevices.getUserMedia({
      video: true
    });
    return "granted";
  } catch (error) {
    if (!isError(error)) {
      return "unknown";
    }
    if (error.name === "NotAllowedError") {
      return "denied";
    } else if (error.name === "NotFoundError") {
      return "notfound";
    } else {
      return "unknown";
    }
  }
}

export { requestCameraPermission };
//# sourceMappingURL=index.js.map
